var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"dark":"","padless":""}},[_c('v-card',{staticClass:"secondary white--text text-center",attrs:{"flat":"","tile":""}},[_c('v-card-text',{staticClass:"white--text"},[_vm._v(" © "+_vm._s(new Date().getFullYear())+" Ternary Innovation, LLC. ")])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }